import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@ingestro/importer-react'

export const root = (isEdition: boolean | undefined, totalRows?: number): ThemeAPI['root'] => {
  // The last index row is the total rows + 2 because the first row is the header and the last one is the
  // add row which is the one we want to hide for edition
  const lastIndexRow = totalRows ? totalRows + 2 : -1
  const isEditionStyles = {
    // Input of the header row to select all rows
    '& thead > tr:first-child > th:first-child > input': {
      display: 'none !important',
    },
    // Input of the rows to select it
    '& tbody > tr > th:first-child input': {
      display: 'none !important',
    },
    // The number of the row when hovering it
    '& tbody > tr:hover .row-header-number': {
      display: 'inline-block !important',
    },
    // Add a new row
    [`& tbody > tr[aria-rowindex="${lastIndexRow}"]`]: {
      display: 'none',
    },
  }

  return {
    container: {
      ...(isEdition ? isEditionStyles : {}),
      // Filters buttons selector
      '& #data-model-sheet-form > div > div > div > div': {
        marginLeft: '0px',
      },
      // Cancel/Back button
      '& #nuvo-footer-root-employee_edition > div > button': {
        backgroundColor: 'rgba(5, 38, 87, 0.06)',
        borderColor: 'rgba(5, 38, 87, 0.06)',
        color: theme.colors.actionSecondary,
        padding: `${theme.dimensions.s6} ${theme.dimensions.s12} ${theme.dimensions.s6} ${theme.dimensions.s8}`,
        borderRadius: theme.borderRadius.abs010,
        display: 'inline-flex',
        width: 'fit-content',
        ':hover': {
          backgroundColor: theme.colors.actionSecondaryBackgroundHover,
          borderColor: theme.colors.actionSecondaryBorderHover,
        },
        ':active': {
          backgroundColor: theme.colors.actionSecondaryBackgroundHover,
          borderColor: theme.colors.actionSecondaryBorderHover,
        },
        '& span': {
          marginLeft: isEdition ? '-2px' : 'inherit',
          '& svg': {
            display: isEdition ? 'none' : 'inline-block',
          },
        },
      },
    },
  }
}
